import styled from '@emotion/styled';
import { Typography } from '@mui/material';

export const TypographyStyled = styled(Typography)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});
